import getDatesRange from "@/mixins/getDatesRange.js";

function getUpcomingSessions(repType, term, allHolidays, weekday) {
    if (repType === undefined) {
        return [];
    }

    const today = new Date(); // Get today's date
    today.setHours(0, 0, 0, 0); // Remove time portion for comparison

    const { start } = term;
    const { end } = term;

    const startDate = new Date(start);
    const endDate = new Date(end);

    // Get holidays for current date range
    const { holidays, deleted } = allHolidays;
    const flatHolidaysTime = holidays?.flat().map((h) => h.time) || [];
    const flatDeleted = deleted?.flat().map((h) => h.time) || [];

    const sessionDates = getDatesRange.methods.getDetailsDateRange(startDate, endDate).map((s) => {
        const sessionDeleted = flatDeleted.indexOf(s.time) !== -1 ? true : s.deleted;

        return {
            ...s,
            deleted: sessionDeleted,
        };
    });

    // Filter out sessions that occur on or before today
    const validSessionDates = sessionDates.filter((s) => new Date(s.time) > today);

    if (repType === "day") {
        // Filter for holiday dates
        return validSessionDates.filter((el) => flatHolidaysTime.indexOf(el.time) === -1);
    }

    if (repType === "week") {
        const days = ["sun", "mon", "tue", "wed", "thu", "fri", "sat"];
        let startWeekDay;

        if (weekday !== undefined) {
            startWeekDay = days.findIndex((el) => el === weekday);
        } else {
            startWeekDay = startDate.getDay();
        }

        // Filter for holiday dates
        return validSessionDates.filter(
            (el) =>
                flatHolidaysTime.indexOf(el.time) === -1 &&
                new Date(el.time).getDay() === startWeekDay
        );
    }

    if (repType === "month-d") {
        const monthDay = startDate.getDate();
        // Filter for holiday dates
        return validSessionDates.filter(
            (el) =>
                flatHolidaysTime.indexOf(el.time) === -1 &&
                new Date(el.time).getDate() === monthDay
        );
    }

    if (repType === "month-w") {
        const startWeekday = startDate.getDay();
        const weekNumber = 4;

        return validSessionDates.filter(
            (el) =>
                flatHolidaysTime.indexOf(el.time) === -1 &&
                new Date(el.time).getDay() === startWeekday &&
                this.getWeekNumOfMonthOfDate(new Date(el.time)) === weekNumber
        );
    }

    if (repType === "none") {
        return validSessionDates;
    }

    return [];
}

export default getUpcomingSessions;
